import React, { createContext, useContext } from 'react';
import useGPSTracker from '../hooks/useGPSTracker';

const GPSContext = createContext(null);

/**
 * Wraps `useGPSTracker` once at the layout level so both the layout's status
 * indicator and the dashboard's start/stop controls share the same tracker
 * instance. Two independent `watchPosition` registrations would otherwise
 * double-count points and conflict on the Service Worker handshake.
 */
export function GPSProvider({ children }) {
  const gps = useGPSTracker();
  return <GPSContext.Provider value={gps}>{children}</GPSContext.Provider>;
}

export function useGPS() {
  const ctx = useContext(GPSContext);
  if (!ctx) {
    throw new Error('useGPS must be used inside <GPSProvider>');
  }
  return ctx;
}
